export default "__VITE_ASSET__D$ACp82H__"